// 巡检类目
const inspectionDeviceTypeJurisdiction = [
  { id: "024001001", label: "添加", children: [] },
  { id: "024001002", label: "修改", children: [] },
  { id: "024001003", label: "删除", children: [] }
];

// 巡检点管理
const inspectionDeviceJurisdiction = [
  { id: "024002001", label: "添加", children: [] },
  { id: "024002002", label: "修改", children: [] },
  { id: "024002003", label: "删除", children: [] },
  { id: "024002004", label: "导入", children: [] },
  { id: "024002005", label: "导出", children: [] }
];

// 巡检人员管理
const inspectionPersonJurisdiction = [
  { id: "024003001", label: "添加", children: [] },
  { id: "024003002", label: "修改", children: [] },
  { id: "024003003", label: "删除", children: [] }
];

// 班组管理
const inspectionTeamJurisdiction = [
  { id: "024004001", label: "添加", children: [] },
  { id: "024004002", label: "修改", children: [] },
  { id: "024004003", label: "删除", children: [] }
];

// 巡检计划
const inspectionPlanJurisdiction = [
  { id: "024005001", label: "添加", children: [] },
  { id: "024005002", label: "修改", children: [] },
  { id: "024005003", label: "删除", children: [] }
];

// 巡检记录
const inspectionRecordJurisdiction = [
  { id: "024007002", label: "导出", children: [] }
];

// 巡检报表
const inspectionReportJurisdiction = [
  { id: "024008001", label: "导出", children: [] }
];

// 智慧巡检
const inspectionServiceJurisdictionChildren = [
  {
    id: "024001000",
    label: "巡检类目",
    routerName: "inspection-device-type-manage",
    children: inspectionDeviceTypeJurisdiction
  },
  {
    id: "024002000",
    label: "巡检点管理",
    routerName: "inspection-device-manage",
    children: inspectionDeviceJurisdiction
  },
  {
    id: "024003000",
    label: "巡检人员管理",
    routerName: "inspection-person-manage",
    children: inspectionPersonJurisdiction
  },
  {
    id: "024004000",
    label: "班组管理",
    routerName: "inspection-team-manage",
    children: inspectionTeamJurisdiction
  },
  {
    id: "024005000",
    label: "计划管理",
    routerName: "inspection-plan-manage",
    children: inspectionPlanJurisdiction
  },
  {
    id: "024006000",
    label: "巡检任务",
    routerName: "inspection-task-manage",
    children: []
  },
  {
    id: "024007000",
    label: "巡检记录",
    routerName: "inspection-record",
    children: inspectionRecordJurisdiction
  },
  {
    id: "024008000",
    label: "巡检报表",
    routerName: "inspection-report",
    children: inspectionReportJurisdiction
  },
  {
    id: "024009000",
    label: "操作日志",
    routerName: "inspection-log",
    children: []
  }
];

const inspectionServiceJurisdiction = {
  id: "024",
  label: "智慧巡检",
  children: inspectionServiceJurisdictionChildren
};

export { inspectionServiceJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/inspectionServiceJurisdiction.js